import React from "react";
import Routers from "../routers";

export const Pages = () => {
  return <Routers />;
};

export default Pages;
